import { render, staticRenderFns } from "./Certificate.vue?vue&type=template&id=00cbd115&scoped=true"
import script from "./Certificate.vue?vue&type=script&lang=js"
export * from "./Certificate.vue?vue&type=script&lang=js"
import style0 from "./Certificate.vue?vue&type=style&index=0&id=00cbd115&prod&lang=less&scoped=true"
import style1 from "./Certificate.vue?vue&type=style&index=1&id=00cbd115&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cbd115",
  null
  
)

export default component.exports